var render = function render(){var _vm=this,_c=_vm._self._c;return (this.isTowerCo() && this.isManager() && this.canAccess('project|maintenance|finance'))?_c('el-button',{attrs:{"icon":"fa fa-trash-alt","size":"small","type":"danger","circle":""},on:{"click":function($event){return _vm.deleteEntry()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }